/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { documentsDelete } from "../../funcs/documentsDelete.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteDocumentRequest$inboundSchema,
};

export const tool$documentsDelete: ToolDefinition<typeof args> = {
  name: "documents-delete",
  description: `Delete a document

Delete a specific document by providing its unique identifier.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await documentsDelete(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(void 0, apiCall);
  },
};
